// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.news-table-filters {
    display: flex;
    justify-content: space-between;
    width: 100%;
}

.toolbar-left {
    display: flex;
    align-items: center;
    gap: 8px;
}

.search-container {
    position: relative;
    display: flex;
    align-items: center;
    height: 34px;
}

.search-icon {
    position: absolute;
    left: 8px;
    color: #6b7280;
    pointer-events: none;
}

.search-input {
    padding: 6px 8px 6px 32px;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 13px;
    width: 320px;
    transition: border-color 0.2s ease;
    height: 34px;
}

.search-input:focus {
    outline: none;
    border-color: #3b82f6;
}

.status-filter {
    position: relative;
}

.status-menu {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1000;
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    margin-top: 4px;
    min-width: 120px;
}

.filter-button {
    padding: 6px 12px;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    background: white;
    color: #374151;
    font-size: 13px;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all 0.2s ease;
    height: 34px;
}

.filter-button:hover {
    background: #f3f4f6;
}

.filter-option {
    padding: 6px 12px;
    width: 100%;
    text-align: left;
    border: none;
    background: white;
    color: #374151;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.filter-option:hover {
    background: #f3f4f6;
}

.bulk-actions-container {
    position: relative;
}

.bulk-actions-button {
    padding: 6px 12px;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    background: white;
    color: #374151;
    font-size: 13px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 6px;
    transition: all 0.2s ease;
    height: 34px;
}

.bulk-actions-button:hover {
    background: #f3f4f6;
}

.bulk-actions-menu {
    position: absolute;
    top: 100%;
    right: 0;
    z-index: 1000;
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    margin-top: 4px;
    min-width: 160px;
}

.bulk-action-button {
    padding: 6px 12px;
    width: 100%;
    text-align: left;
    border: none;
    background: white;
    color: #374151;
    font-size: 13px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 6px;
    transition: all 0.2s ease;
}

.bulk-action-button:hover {
    background: #f3f4f6;
}

.refresh-button {
    background-color: #2a5298 !important;
    color: white !important;
    border: none !important;
    border-radius: 4px !important;
    padding: 6px 12px !important;
    cursor: pointer !important;
    transition: background-color 0.3s ease !important;
    display: flex !important;
    align-items: center !important;
    gap: 6px !important;
    font-size: 13px !important;
    height: 34px !important;
    position: relative !important;
    z-index: 1 !important;
}

.refresh-button:hover {
    background-color: #23487f !important;
    color: white !important;
}

.refresh-button:disabled {
    background-color: #6c757d !important;
    cursor: not-allowed !important;
}

.spinning {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

/* Добавим новые стили */
.action-button {
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    transition: all 0.2s ease;
}

.action-button:hover {
    background-color: #f3f4f6;
}

.bulk-actions-counter {
    background-color: #3b82f6;
    color: white;
    padding: 2px 6px;
    border-radius: 12px;
    font-size: 12px;
    margin-left: 4px;
}

.reset-filter-button {
    background-color: #fff;
    border: 1px solid #dc2626;
    border-radius: 4px;
    padding: 6px 12px;
    color: #dc2626;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    height: 31px;
}

.reset-filter-button:hover {
    background-color: #fee2e2;
    border-color: #dc2626;
}

.reset-filter-button .close-icon {
    font-size: 16px;
    line-height: 1;
    margin-left: 4px;
}

.refresh-button-icon {
    font-size: 18px;
    color: #ef4444;
}

.loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.7);
    z-index: 1;
    pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/styles/NewsTableFilters.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,kCAAkC;IAClC,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,aAAa;IACb,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,yCAAyC;IACzC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,aAAa;IACb,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,yCAAyC;IACzC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;IACvB,uBAAuB;IACvB,6BAA6B;IAC7B,4BAA4B;IAC5B,0BAA0B;IAC1B,iDAAiD;IACjD,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;IACnB,0BAA0B;IAC1B,uBAAuB;IACvB,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,8BAA8B;AAClC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA,wBAAwB;AACxB;IACI,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,UAAU;IACV,oBAAoB;AACxB","sourcesContent":[".news-table-filters {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.toolbar-left {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.search-container {\n    position: relative;\n    display: flex;\n    align-items: center;\n    height: 34px;\n}\n\n.search-icon {\n    position: absolute;\n    left: 8px;\n    color: #6b7280;\n    pointer-events: none;\n}\n\n.search-input {\n    padding: 6px 8px 6px 32px;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    font-size: 13px;\n    width: 320px;\n    transition: border-color 0.2s ease;\n    height: 34px;\n}\n\n.search-input:focus {\n    outline: none;\n    border-color: #3b82f6;\n}\n\n.status-filter {\n    position: relative;\n}\n\n.status-menu {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    z-index: 1000;\n    background: white;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n    margin-top: 4px;\n    min-width: 120px;\n}\n\n.filter-button {\n    padding: 6px 12px;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    background: white;\n    color: #374151;\n    font-size: 13px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    transition: all 0.2s ease;\n    height: 34px;\n}\n\n.filter-button:hover {\n    background: #f3f4f6;\n}\n\n.filter-option {\n    padding: 6px 12px;\n    width: 100%;\n    text-align: left;\n    border: none;\n    background: white;\n    color: #374151;\n    font-size: 13px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.filter-option:hover {\n    background: #f3f4f6;\n}\n\n.bulk-actions-container {\n    position: relative;\n}\n\n.bulk-actions-button {\n    padding: 6px 12px;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    background: white;\n    color: #374151;\n    font-size: 13px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    transition: all 0.2s ease;\n    height: 34px;\n}\n\n.bulk-actions-button:hover {\n    background: #f3f4f6;\n}\n\n.bulk-actions-menu {\n    position: absolute;\n    top: 100%;\n    right: 0;\n    z-index: 1000;\n    background: white;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n    margin-top: 4px;\n    min-width: 160px;\n}\n\n.bulk-action-button {\n    padding: 6px 12px;\n    width: 100%;\n    text-align: left;\n    border: none;\n    background: white;\n    color: #374151;\n    font-size: 13px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    transition: all 0.2s ease;\n}\n\n.bulk-action-button:hover {\n    background: #f3f4f6;\n}\n\n.refresh-button {\n    background-color: #2a5298 !important;\n    color: white !important;\n    border: none !important;\n    border-radius: 4px !important;\n    padding: 6px 12px !important;\n    cursor: pointer !important;\n    transition: background-color 0.3s ease !important;\n    display: flex !important;\n    align-items: center !important;\n    gap: 6px !important;\n    font-size: 13px !important;\n    height: 34px !important;\n    position: relative !important;\n    z-index: 1 !important;\n}\n\n.refresh-button:hover {\n    background-color: #23487f !important;\n    color: white !important;\n}\n\n.refresh-button:disabled {\n    background-color: #6c757d !important;\n    cursor: not-allowed !important;\n}\n\n.spinning {\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n/* Добавим новые стили */\n.action-button {\n    border: none;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 4px;\n    transition: all 0.2s ease;\n}\n\n.action-button:hover {\n    background-color: #f3f4f6;\n}\n\n.bulk-actions-counter {\n    background-color: #3b82f6;\n    color: white;\n    padding: 2px 6px;\n    border-radius: 12px;\n    font-size: 12px;\n    margin-left: 4px;\n}\n\n.reset-filter-button {\n    background-color: #fff;\n    border: 1px solid #dc2626;\n    border-radius: 4px;\n    padding: 6px 12px;\n    color: #dc2626;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 13px;\n    height: 31px;\n}\n\n.reset-filter-button:hover {\n    background-color: #fee2e2;\n    border-color: #dc2626;\n}\n\n.reset-filter-button .close-icon {\n    font-size: 16px;\n    line-height: 1;\n    margin-left: 4px;\n}\n\n.refresh-button-icon {\n    font-size: 18px;\n    color: #ef4444;\n}\n\n.loading-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(255, 255, 255, 0.7);\n    z-index: 1;\n    pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
